import React, { useState } from "react";
import { FiSave, FiArrowLeft, FiHash, FiCpu } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { showSuccessToast, showErrorToast } from "../../../../utils/toastUtils";
import { makeRequestAuth } from "../../../../_config/api";

function CreateQrCode() {
  const navigate = useNavigate();
  const [address, setAddress] = useState("");
  const [network, setNetwork] = useState("TRC20");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!address.trim()) {
      return showErrorToast("Address is required");
    }

    try {
      setSubmitting(true);

      const response = await makeRequestAuth("post", "/admin/createQrCode", {
        address: address,
        network: network,
      });

      if (!response.error) {
        showSuccessToast("QR Code created successfully!");
        setTimeout(() => navigate("/qr-code"), 1500);
      } else {
        showErrorToast(response.message || "Failed to create QR Code");
      }
    } catch (err) {
      console.error("QR Error:", err);
      showErrorToast(err.response?.data?.message || "Server error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="p-4">
      <div className="max-w-2xl mx-auto bg-white dark:bg-[#1E2738] rounded-2xl p-6 md:p-8 border border-purple-300 dark:border-purple-600/50 shadow-xl">
        {/* Header */}
        <div className="flex justify-between items-center mb-8 border-b border-gray-200 dark:border-gray-700 pb-4">
          <div>
            <h2 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              Create New QR Code TOKEN
            </h2>
          </div>
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-gray-500 hover:text-purple-600 transition"
          >
            <FiArrowLeft size={20} /> Back
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          {/* Network Selection */}
          <div className="mb-6">
            <label className="block text-gray-700 dark:text-gray-300 font-medium mb-2">
              Network <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <FiCpu className="text-gray-400" />
              </div>
              <select
                value={network}
                onChange={(e) => setNetwork(e.target.value)}
                className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700/50 text-gray-800 dark:text-white focus:ring-2 focus:ring-purple-500 outline-none transition cursor-pointer appearance-none"
                required
              >
                <option value="TRC20">TRC20</option>
                <option value="ERC20">ERC20</option>
                <option value="BEP20">BEP20</option>
              </select>
            </div>
          </div>

          {/* Address Input */}
          <div className="mb-6">
            <label className="block text-gray-700 dark:text-gray-300 font-medium mb-2">
              Address <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <FiHash className="text-gray-400" />
              </div>
              <input
                type="text"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                placeholder="Enter wallet address"
                className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700/50 text-gray-800 dark:text-white focus:ring-2 focus:ring-purple-500 outline-none transition"
                required
              />
            </div>
          </div>

          <div className="flex justify-end gap-4">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="px-6 py-2.5 rounded-xl border border-gray-300 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="flex items-center gap-2 px-8 py-2.5 rounded-xl bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold shadow-lg disabled:opacity-50 transition"
            >
              {submitting ? (
                "Saving..."
              ) : (
                <>
                  <FiSave /> Save Address
                </>
              )}
            </button>
          </div>
        </form>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}

export default CreateQrCode;
